module.exports = __webpack_public_path__ + "img/rgm.2ebdf2e4.png";